export default "__VITE_ASSET__68672f2a__"